import { ActionTree } from 'vuex';
import { AuthState } from './types';
import { RootState } from '../../types';
import { Logger } from 'fsts';
import module_utils from '../module_utils';
import { AxiosResponse } from 'axios';
import i18n from '@/i18n';
import DownloadUtils from '@/shared/utils/DownloadUtils';
import { Credentials } from '@/shared/model/smallPayloadModels/credentials';
import { defaultBackendAccount } from '@/shared/backend/account';
// import { msalInstance } from 'vue-msal-browser';
import msalPlugin, { msalInstance } from 'vue-msal-browser';

const logger = new Logger('actions.auth');
export const actions: ActionTree<AuthState, RootState> = {
  updateAzureData({ commit }, payload: any) {
    commit('setAzureData', payload);
  },

  async login({ commit, dispatch }, payload: Credentials) {
    // authenticate to get the access token
    return defaultBackendAccount
      .authenticate(payload.username!, payload.password!, payload.rememberMe)
      .then((response: any) => {
        commit('setToken', response.data);
        commit('setAccountId', response.data.userId);
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async loadAccountDetails({ commit }, id?: number) {
    return defaultBackendAccount
      .getMyAccount()
      .then((account) => {
        commit('setAccount', account.data.account);
      })
      .catch((e) => {
        commit('setAccount', undefined);
        module_utils.error('', commit, e);
      });
  },

  async loadAzureUserId({ commit }, email: string) {
    return defaultBackendAccount
      .loadAzureUserId(email)
      .then((response) => {
        const id = response.data?.value[0]?.id;
        return id;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async isInGroup({ commit }, email: string) {
    return defaultBackendAccount
      .isInGroup(email)
      .then((response) => {
        // const isInAdminGroup = response.data && response.data > 0;
        // console.log('isInAdminGroup :>> ', isInAdminGroup2);
        // logger.log('isInGroup :>> ', response.data);
        return response.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async canSeeAll({ commit }, email: string) {
    return defaultBackendAccount
      .canSeeAllCompanyContacts(email)
      .then((response) => {
        const isInAdminGroup = response.data?.value?.length > 0;
        logger.log('isInAdminGroup :>> ', response.data);
        commit('setIsUserInAzureAdminGroup', isInAdminGroup);
        commit('setUserAdminGroups', response.data?.value);
        return response.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async addInAzureHausAdminGroup({ commit }, payload: any) {
    return defaultBackendAccount
      .addInAzureHausAdminGroup(payload)
      .then((response) => {
        logger.log('addInAzureHausAdminGroup action response :>> ', response);
        return response.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async addRemoveInAzureZrPortalGroup({ commit }, payload: any) {
    return defaultBackendAccount
      .addRemoveInAzureZrPortalGroup(payload)
      .then((response) => {
        logger.log('addRemoveInAzureZrPortalGroup action response :>> ', response);
        return response.data;
      })
      .catch((e: any) => {
        if (e.response?.data?.errors && e.response.data.errors.length > 0 && e.response.data.errors[0]?.description) {
          var errorMessage = e.response.data.errors[0].description;

          if (errorMessage.toLowerCase().includes('tbl_sync_testuser')) {
            errorMessage = 'Sie sind im Staging. Der Sync läuft nur für die User aus der Tabelle "tbl_sync_testuser".';
          }
          module_utils.error(errorMessage, commit, e, logger);
          throw e;
        }
        // logger.error(e);
        logger.error(e?.response?.data);
        throw e;
      });
  },

  async deactivateUserOnAzure({ commit }, payload: any) {
    return defaultBackendAccount
      .deactivateUserOnAzure(payload)
      .then((response) => {
        return response;
      })
      .catch((e: any) => {
        if (e.response?.data?.errors && e.response.data.errors.length > 0 && e.response.data.errors[0]?.description) {
          var errorMessage = e.response.data.errors[0].description;

          if (errorMessage.toLowerCase().includes('tbl_sync_testuser')) {
            errorMessage = 'Sie sind im Staging. Der Sync läuft nur für die User aus der Tabelle "tbl_sync_testuser".';
          }
          module_utils.error(errorMessage, commit, e, logger);
          throw e;
        }

        logger.error(e);
        throw e;
      });
  },
  async activateUserOnAzure({ commit }, azureUserId: string) {
    return defaultBackendAccount
      .activateUserOnAzure(azureUserId)
      .then((response) => {
        return response;
      })
      .catch((e: any) => {
        if (e.response?.data?.errors && e.response.data.errors.length > 0 && e.response.data.errors[0]?.description) {
          var errorMessage = e.response.data.errors[0].description;

          if (errorMessage.toLowerCase().includes('tbl_sync_testuser')) {
            errorMessage = 'Sie sind im Staging. Der Sync läuft nur für die User aus der Tabelle "tbl_sync_testuser".';
          }
          module_utils.error(errorMessage, commit, e, logger);
          throw e;
        }

        logger.error(e);
        throw e;
      });
  },

  async getVmeSupplierData({ commit }, supplierId: string) {
    console.log('getVmeSupplierData supplierId:>> ', supplierId);
    return defaultBackendAccount
      .getVmeSupplierData(supplierId)
      .then((response) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getVmeSupplierUmsatz({ commit }, data: any) {
    console.log('getVmeSupplierUmsatz :>> ', data);
    return defaultBackendAccount
      .getVmeSupplierUmsatz(data)
      .then((response) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async getVmeStatisticsData({ commit }, data: any) {
    console.log('getVmeStatisticsData :>> ', data);
    return defaultBackendAccount
      .getVmeStatisticsData(data)
      .then((response) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async getVmeApiUserId({ commit }, email: string) {
    console.log('getVmeApiUserId supplierId:>> ', email);
    return defaultBackendAccount
      .getVmeApiUserId(email)
      .then((response) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async getEnvironment({ commit }, data: string) {
    return defaultBackendAccount
      .getEnvironment()
      .then((response) => {
        commit('setEnvironment', response.data);
        return response.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  async addUpdateVmeApiUser({ commit }, data: any) {
    return defaultBackendAccount
      .addUpdateVmeApiUser(data)
      .then((response) => {
        return response.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },

  /**
   * Clears the userType effectively logging out the user.
   */
  logout({ commit }) {
    return defaultBackendAccount.logout().then((result) => {
      commit('setAccount', undefined);
      commit('clearTokens');
      return result;
    });
  },
  async getSupportContacts({ commit }) {
    return defaultBackendAccount
      .getSupportContacts()
      .then((result: AxiosResponse<any>) => {
        commit('setLoadSupportContactList', true);
        return result.data;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  async LogFormActions({ commit }, payload: any) {
    return defaultBackendAccount
      .LogFormActions(payload)
      .then((response) => {
        return response;
      })
      .catch((e: any) => {
        logger.error(e);
        throw e;
      });
  },
  updateInitialRedirect({ commit }, payload: any) {
    commit('setInitialRedirect', payload);
  },
};
